import {AccountConfigModule} from '@abp/ng.account/config';
import {CoreModule} from '@abp/ng.core';
import {IdentityConfigModule} from '@abp/ng.identity/config';
import {SettingManagementConfigModule} from '@abp/ng.setting-management/config';
import {TenantManagementConfigModule} from '@abp/ng.tenant-management/config';
import {ThemeBasicModule} from '@abp/ng.theme.basic';
import {ThemeSharedModule} from '@abp/ng.theme.shared';
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgxsModule} from '@ngxs/store';
import {environment} from '../environments/environment';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {APP_ROUTE_PROVIDER} from './route.provider';
import {CustomerSearchComponent} from './components/customer-search/customer-search.component';
import {IconsProviderModule} from './icons-provider.module';
import {NzLayoutModule} from 'ng-zorro-antd/layout';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {NZ_I18N} from 'ng-zorro-antd/i18n';
import {zh_CN} from 'ng-zorro-antd/i18n';
import {registerLocaleData, LocationStrategy, HashLocationStrategy, PathLocationStrategy} from '@angular/common';
import {RouterModule, NoPreloading, RouteReuseStrategy, PreloadAllModules} from '@angular/router';
import {SimpleReuseStrategy} from './strategy/simple-reuse-strategy';
import zh from '@angular/common/locales/zh';
import {
  NzTabsModule,
  NzSpinModule,
  NzButtonModule,
  NzModalModule,
  NzAutocompleteModule,
  NzConfig, NZ_CONFIG,
  NzEmptyModule, NzSwitchModule, NzInputModule, NzToolTipModule, NzBadgeModule, NzGridModule, NzProgressModule, NzFormModule
} from 'ng-zorro-antd';
import {NzMessageService} from 'ng-zorro-antd';
import {SystemConfigurationService} from './pages/system-configuration/system-configuration.service';
import {NzCarouselModule} from 'ng-zorro-antd/carousel';
import {NzPopoverModule} from 'ng-zorro-antd/popover';
import {NzNotificationService} from 'ng-zorro-antd';
import { ComponentModule } from './common/commponents/component.module';
import { AnnouncementModalModule } from './pages/basic-form/announcement-modal/announcement-modal.module';
import { TreeModule } from '@circlon/angular-tree-component';

registerLocaleData(zh);

function isEmbeddedMode(): boolean {
  try {
    const url = new URL(window.location.href);
    const embedParam = getQueryParam(url, 'embed').toLowerCase();
    return !!window['__REVENUE_MICRO_APP_EMBED__'] || !!window['__MICRO_APP_ENVIRONMENT__'] || !!window['microApp'] || embedParam === '1' || embedParam === 'true' || window.self !== window.top;
  } catch {
    return false;
  }
}

function getQueryParam(url: URL, key: string): string {
  const value = url.searchParams.get(key);
  if (value) {
    return value;
  }

  const hashQueryIndex = url.hash.indexOf('?');
  if (hashQueryIndex === -1) {
    return '';
  }

  return new URLSearchParams(url.hash.slice(hashQueryIndex + 1)).get(key) || '';
}

function isIdentityRedirect(uri: string): boolean {
  try {
    const target = new URL(uri, window.location.origin);
    const issuer = new URL(environment.oAuthConfig.issuer, window.location.origin);
    return target.origin === issuer.origin;
  } catch {
    return false;
  }
}

function openOAuthUri(uri: string): void {
  if (isEmbeddedMode() && isIdentityRedirect(uri)) {
    console.warn('[RevenueMicroApp][Child] blocked identity redirect in embed mode', { uri });
    return;
  }

  window.location.href = uri;
}

const runtimeEnvironment = {
  ...environment,
  oAuthConfig: {
    ...environment.oAuthConfig,
    openUri: openOAuthUri,
  },
};

const ngZorroConfig: NzConfig = {
  // 注意组件名称没有 nz 前缀
  table: {
    nzShowQuickJumper: true,
  },
  message: {
    nzTop: 88,
  }
};

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule.forRoot({
      environment: runtimeEnvironment as any
    }),
    ThemeSharedModule.forRoot(),
    AccountConfigModule.forRoot(),
    IdentityConfigModule.forRoot(),
    TenantManagementConfigModule.forRoot(),
    SettingManagementConfigModule.forRoot(),
    NgxsModule.forRoot(),
    ThemeBasicModule.forRoot(),
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    FormsModule,
    HttpClientModule,
    NzTabsModule,
    NzSpinModule,
    NzButtonModule,
    NzCarouselModule,
    NzPopoverModule,
    NzModalModule,
    NzAutocompleteModule,
    NzEmptyModule,
    NzSwitchModule,
    NzInputModule,
    NzToolTipModule,
    NzBadgeModule,
    NzGridModule,
    NzProgressModule,
    ComponentModule,
    AnnouncementModalModule,
    NzFormModule,
    TreeModule
  ],
  declarations: [
    AppComponent,
    CustomerSearchComponent,
  ],
  providers: [
    APP_ROUTE_PROVIDER,
    {provide: NZ_I18N, useValue: zh_CN},
    SystemConfigurationService,
    NzMessageService,
    NzNotificationService,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    {
      provide: RouteReuseStrategy,
      useClass: SimpleReuseStrategy,
    },
    { provide: NZ_CONFIG, useValue: ngZorroConfig },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
